"use client";
import React from 'react';
import {
  Modal as ModalMUI,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.scss';

type ModalProps = {
    open: boolean
    ctaClose?: string
    ctaSubmit?: string
    body?: React.ReactNode
    onClose?: () => void
    onSubmit?: () => void
    title?: string
    width?: string
    height?: string
    ctaSecondary?: string
    handleCtaSecondary?: () => void
}

const Modal = ({
  open,
  ctaClose,
  ctaSubmit,
  body,
  onClose,
  onSubmit,
  title,
  width,
  height,
  ctaSecondary,
  handleCtaSecondary,
}: ModalProps) => {

  return (
    <ModalMUI
      open={open}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div className={styles.contenedor} style={{ maxWidth: width ?? '600px', height: height ?? '300px' }}>
        {(title || (onClose && ctaClose)) &&
                    <div className={styles.header}>
                      {title && <Typography variant="h6">{title}</Typography>}
                      {onClose &&
                            <IconButton
                              size="small"
                              aria-label="close-modal"
                              color="inherit"
                              onClick={onClose}
                              className={styles.closeButton}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                      }
                    </div>
        }
        {body &&
                    <div className={styles.scroll}>
                      {body}
                    </div>
        }
        {((ctaClose && onClose) || (ctaSecondary && handleCtaSecondary) || (ctaSubmit && onSubmit)) &&
                    <div className={styles.footer}>
                      {ctaClose && onClose && (
                        <Button
                          variant="text"
                          color="primary"
                          onClick={onClose}
                        >
                          {ctaClose}
                        </Button>
                      )}
                      {(ctaSecondary && handleCtaSecondary) && (
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => handleCtaSecondary()}
                        >
                          {ctaSecondary}
                        </Button>
                      )}
                      {(ctaSubmit && onSubmit) && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => onSubmit()}
                        >
                          {ctaSubmit}
                        </Button>
                      )}
                    </div>
        }
      </div>
    </ModalMUI>
  );
};

export default Modal;
